import { NewButton } from "..";
import { ButtonTypes } from "../../Definitions";
import { colors, css, fonts, glyphs, icons } from "../../Styles";
import { CSSProperties } from "react";

export enum Themes {
  darkmode="darkmode",
  lightmode="lightmode"
}

interface AnimalNumberDisplayProps {
  header: string;
  content: string | JSX.Element | number;
  state?: number;
  style?: CSSProperties;
  theme?: Themes;
  secondaryContent?: string
  onClick?: () => void;
}

export default function AnimalNumberDisplay({ header, content, state, secondaryContent, style, onClick, theme = Themes.darkmode }:AnimalNumberDisplayProps) {

  return (
    <div style={{ display: "grid", gridTemplateColumns: "45px 1fr", gridTemplateRows: "14px 14px 12px", rowGap: "5px", columnGap: "10px", ...style }}>
      
      <div style={{ gridArea: "1/1/4/2"}}>
        {theme === Themes.lightmode ?
          <glyphs.Animal size="45px" /> :
          <img src={icons.animalsColor} style={{ width: "45px", height: "45px" }} alt={""} />
        }
      </div>
      
      <div style={{ gridArea: "1/2/2/3", paddingTop: "3px" }}>
        <p style={{ color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyPrimary, ...fonts.fontSize4, ...fonts.header }}>
          {header}
        </p>
      </div>
        
      <div style={{ gridArea: "2/2/3/3", display: "flex", alignItems: "center" }}>
        { state === 1 ?
          <NewButton
            content={content.toString()}
            buttonType={ButtonTypes.textButton}
            overrides={{
              contentStyles: { ...fonts.fontSize3, ...fonts.header, color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyDarkPrimary }
            }}
            onClick={onClick}
          />
        : state === 0 ?
          <p style={{ ...css.emptyPen, ...fonts.fontSize3, color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyPrimary, opacity: "0.5" }}>
            {content}
          </p>
        : state === 2 ?
          <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.systemRed }}>
            {content}
          </p>
        : <></> }
      </div>
        
      <div style={{ gridArea: "3/2/4/3", display: "flex", alignItems: "center" }}>
        {secondaryContent ? <p style={{ ...fonts.fontSize4, ...fonts.paragraph, opacity: "0.5", color: theme === Themes.lightmode ? colors.greyLightTertiary : colors.greyPrimary }}>
          {secondaryContent}
        </p> : <></>}
      </div>

    </div>
  )
}